import { AppQueryStrings, AppRoutes } from "../../enums";
import type { DialogMessage } from "../../services/dialog/dialog.interface";

/**
 * Whether this app instance is the one Shopify loads inside a modal (`/:programSlug/dialog/<key>`): a second copy of
 * the admin that only renders one dialog for the page that opened it.
 */
export const isDialogHostPath = (pathname: string = window.location.pathname): boolean =>
  pathname.split("/").filter(Boolean)[1] === AppRoutes.dialog;

/** Inside a Shopify modal, the id of the dialog this frame shows for the page that opened it; `null` anywhere else. */
export const dialogHostId = (): string | null =>
  isDialogHostPath() && window.opener ? new URLSearchParams(window.location.search).get(AppQueryStrings.dialogId) : null;

/**
 * Downloads a file. Inside a Shopify modal the page that opened it starts the download, because the modal frame is
 * nested in Shopify's admin and may not be allowed to download.
 */
export const downloadFile = (filename: string, href: string): void => {
  const dialogId = dialogHostId();
  if (dialogId) {
    const message: DialogMessage = { type: "dialog-download", dialogId, filename, href };
    window.opener.postMessage(message, window.location.origin);
    return;
  }

  const link = document.createElement("a");
  link.download = filename;
  link.href = href;
  link.click();
};
